/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  CreatePendingSeatingBookingRequest,
  CreateSeatingBookingRequest,
  GetSevenRoomsAvailabilityV1Params,
  GetSevenRoomsSeatingAreasV1Params,
  GetSevenRoomsVenuesV1Params,
  SeatingAreaDto,
  SeatingClientTagGroupDto,
  SeatingReservationDto,
  ShiftAvailabilityDto,
  VenueDto
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type requestSevenRoomsReservationV1Response200 = {
  data: SeatingReservationDto
  status: 200
}

export type requestSevenRoomsReservationV1Response400 = {
  data: void
  status: 400
}

export type requestSevenRoomsReservationV1Response401 = {
  data: void
  status: 401
}

export type requestSevenRoomsReservationV1Response502 = {
  data: void
  status: 502
}

export type requestSevenRoomsReservationV1ResponseSuccess = (requestSevenRoomsReservationV1Response200) & {
  headers: Headers;
};
export type requestSevenRoomsReservationV1ResponseError = (requestSevenRoomsReservationV1Response400 | requestSevenRoomsReservationV1Response401 | requestSevenRoomsReservationV1Response502) & {
  headers: Headers;
};

export type requestSevenRoomsReservationV1Response = (requestSevenRoomsReservationV1ResponseSuccess | requestSevenRoomsReservationV1ResponseError)

export const getRequestSevenRoomsReservationV1Url = () => {




  return `/api/v1/reservations/sevenrooms/booking-requests`
}

/**
 * Calls SevenRooms /request and persists the reservation as Pending. The venue staff resolve it in the SevenRooms backoffice. Used both for normal pending flows and the "Book anyway" UX (unavailable slot). Body schema is intentionally a different type from /bookings — it has no SelectedTags field because the underlying SevenRooms /request endpoint does not support tags. Requires an Idempotency-Key header (client-generated GUID) — same 24h dedupe as /bookings.
 * @summary Create a pending booking request
 */
export const requestSevenRoomsReservationV1 = async (createPendingSeatingBookingRequest: CreatePendingSeatingBookingRequest, options?: Parameters<typeof customFetch>[1]): Promise<requestSevenRoomsReservationV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<requestSevenRoomsReservationV1Response>(getRequestSevenRoomsReservationV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPendingSeatingBookingRequest)
  }
);}


export type bookSevenRoomsReservationV1Response200 = {
  data: SeatingReservationDto
  status: 200
}

export type bookSevenRoomsReservationV1Response400 = {
  data: void
  status: 400
}

export type bookSevenRoomsReservationV1Response401 = {
  data: void
  status: 401
}

export type bookSevenRoomsReservationV1Response502 = {
  data: void
  status: 502
}

export type bookSevenRoomsReservationV1ResponseSuccess = (bookSevenRoomsReservationV1Response200) & {
  headers: Headers;
};
export type bookSevenRoomsReservationV1ResponseError = (bookSevenRoomsReservationV1Response400 | bookSevenRoomsReservationV1Response401 | bookSevenRoomsReservationV1Response502) & {
  headers: Headers;
};

export type bookSevenRoomsReservationV1Response = (bookSevenRoomsReservationV1ResponseSuccess | bookSevenRoomsReservationV1ResponseError)

export const getBookSevenRoomsReservationV1Url = () => {




  return `/api/v1/reservations/sevenrooms/bookings`
}

/**
 * Calls SevenRooms /book and persists the reservation as Confirmed. Fails if the slot is unavailable. Requires an Idempotency-Key header (client-generated GUID) to dedupe network retries — the first successful response is cached for 24 hours per (user, key).
 * @summary Create a confirmed booking
 */
export const bookSevenRoomsReservationV1 = async (createSeatingBookingRequest: CreateSeatingBookingRequest, options?: Parameters<typeof customFetch>[1]): Promise<bookSevenRoomsReservationV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<bookSevenRoomsReservationV1Response>(getBookSevenRoomsReservationV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createSeatingBookingRequest)
  }
);}


export type getSevenRoomsVenuesV1Response200 = {
  data: VenueDto[]
  status: 200
}

export type getSevenRoomsVenuesV1Response500 = {
  data: void
  status: 500
}

export type getSevenRoomsVenuesV1ResponseSuccess = (getSevenRoomsVenuesV1Response200) & {
  headers: Headers;
};
export type getSevenRoomsVenuesV1ResponseError = (getSevenRoomsVenuesV1Response500) & {
  headers: Headers;
};

export type getSevenRoomsVenuesV1Response = (getSevenRoomsVenuesV1ResponseSuccess | getSevenRoomsVenuesV1ResponseError)

export const getGetSevenRoomsVenuesV1Url = (params?: GetSevenRoomsVenuesV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reservations/sevenrooms/venues?${stringifiedParams}` : `/api/v1/reservations/sevenrooms/venues`
}

/**
 * Returns venues that have at least one published + active BookableService. Optionally filter by location and by the service category the user entered through. No ServiceType restriction is applied — the serviceCategoryNodeKey is the discriminator.
 * @summary List venues that have at least one SevenRooms BookableService
 */
export const getSevenRoomsVenuesV1 = async (params?: GetSevenRoomsVenuesV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getSevenRoomsVenuesV1Response> => {

  return customFetch<getSevenRoomsVenuesV1Response>(getGetSevenRoomsVenuesV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getSevenRoomsAvailabilityV1Response200 = {
  data: ShiftAvailabilityDto[]
  status: 200
}

export type getSevenRoomsAvailabilityV1Response400 = {
  data: void
  status: 400
}

export type getSevenRoomsAvailabilityV1Response502 = {
  data: void
  status: 502
}

export type getSevenRoomsAvailabilityV1ResponseSuccess = (getSevenRoomsAvailabilityV1Response200) & {
  headers: Headers;
};
export type getSevenRoomsAvailabilityV1ResponseError = (getSevenRoomsAvailabilityV1Response400 | getSevenRoomsAvailabilityV1Response502) & {
  headers: Headers;
};

export type getSevenRoomsAvailabilityV1Response = (getSevenRoomsAvailabilityV1ResponseSuccess | getSevenRoomsAvailabilityV1ResponseError)

export const getGetSevenRoomsAvailabilityV1Url = (venueNodeKey: string,
    params?: GetSevenRoomsAvailabilityV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reservations/sevenrooms/venues/${venueNodeKey}/availability?${stringifiedParams}` : `/api/v1/reservations/sevenrooms/venues/${venueNodeKey}/availability`
}

/**
 * Returns one entry per shift defined by the venue for that date, with every slot pre-computed from the shift's IntervalMinutes. Each slot carries IsAvailable plus the list of seating areas that can serve it. Slots already in the past (Europe/Lisbon) are dropped from the response entirely — only future slots for the current day are returned. When seatingAreaPublicGuid is supplied, availability is restricted to that single seating area. When serviceCategoryNodeKey is supplied, the seating-area scope is further restricted to areas assigned to that category in the operator's matrix. When occurrenceId is supplied (an event occurrence id from the event detail's occurrences[]), only the shifts open at that occurrence's start time are returned — an event at 23:00 no longer offers the lunch shift. The occurrence's own time is used (never a client-supplied one) and is read in Europe/Lisbon wall-clock. The full grid is served unchanged when the occurrence is all-day, falls on another date, is unknown, or when no open shift covers its start time.
 * @summary Get the full shift grid (Lunch/Dinner) cross-referenced with SevenRooms availability
 */
export const getSevenRoomsAvailabilityV1 = async (venueNodeKey: string,
    params?: GetSevenRoomsAvailabilityV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getSevenRoomsAvailabilityV1Response> => {

  return customFetch<getSevenRoomsAvailabilityV1Response>(getGetSevenRoomsAvailabilityV1Url(venueNodeKey,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getSevenRoomsClientTagsV1Response200 = {
  data: SeatingClientTagGroupDto[]
  status: 200
}

export type getSevenRoomsClientTagsV1Response500 = {
  data: void
  status: 500
}

export type getSevenRoomsClientTagsV1ResponseSuccess = (getSevenRoomsClientTagsV1Response200) & {
  headers: Headers;
};
export type getSevenRoomsClientTagsV1ResponseError = (getSevenRoomsClientTagsV1Response500) & {
  headers: Headers;
};

export type getSevenRoomsClientTagsV1Response = (getSevenRoomsClientTagsV1ResponseSuccess | getSevenRoomsClientTagsV1ResponseError)

export const getGetSevenRoomsClientTagsV1Url = (venueNodeKey: string,) => {




  return `/api/v1/reservations/sevenrooms/venues/${venueNodeKey}/client-tags`
}

/**
 * Returns the SevenRooms reservation tag groups the user can pick from when creating a booking. The catalog is sourced from the Umbraco Reservation Tag Repository (groups → tags). Each group/tag carries the SR canonical id (Umbraco 'externalId' property) plus the culture-aware node Name resolved via the 'Accept-Language' header. Cached in-memory per culture. Returns 500 when the venue has no SevenRooms ExternalId configured in the CMS.
 * @summary List SevenRooms reservation tag groups exposed at booking time (localised)
 */
export const getSevenRoomsClientTagsV1 = async (venueNodeKey: string, options?: Parameters<typeof customFetch>[1]): Promise<getSevenRoomsClientTagsV1Response> => {

  return customFetch<getSevenRoomsClientTagsV1Response>(getGetSevenRoomsClientTagsV1Url(venueNodeKey),
  {
    ...options,
    method: 'GET'


  }
);}


export type getSevenRoomsSeatingAreasV1Response200 = {
  data: SeatingAreaDto[]
  status: 200
}

export type getSevenRoomsSeatingAreasV1Response500 = {
  data: void
  status: 500
}

export type getSevenRoomsSeatingAreasV1ResponseSuccess = (getSevenRoomsSeatingAreasV1Response200) & {
  headers: Headers;
};
export type getSevenRoomsSeatingAreasV1ResponseError = (getSevenRoomsSeatingAreasV1Response500) & {
  headers: Headers;
};

export type getSevenRoomsSeatingAreasV1Response = (getSevenRoomsSeatingAreasV1ResponseSuccess | getSevenRoomsSeatingAreasV1ResponseError)

export const getGetSevenRoomsSeatingAreasV1Url = (venueNodeKey: string,
    params?: GetSevenRoomsSeatingAreasV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reservations/sevenrooms/venues/${venueNodeKey}/seating-areas?${stringifiedParams}` : `/api/v1/reservations/sevenrooms/venues/${venueNodeKey}/seating-areas`
}

/**
 * Returns the seating areas of a venue. Optionally restricted to a service category (matches the operator's matrix assignment) so a venue with bookable services across multiple categories does not leak unrelated areas.
 * @summary List seating areas inside a venue
 */
export const getSevenRoomsSeatingAreasV1 = async (venueNodeKey: string,
    params?: GetSevenRoomsSeatingAreasV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getSevenRoomsSeatingAreasV1Response> => {

  return customFetch<getSevenRoomsSeatingAreasV1Response>(getGetSevenRoomsSeatingAreasV1Url(venueNodeKey,params),
  {
    ...options,
    method: 'GET'


  }
);}


